__webpack_require__.p = "https://assets.canny.io/eac9495cc902ceaf2607c17fd8957c12dd56bbc6/";